module.exports = require("core-js/library/fn/object/freeze");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/core-js/object/freeze.js
// module id = 180
// module chunks = 0 1